import { deleteRequest, getRequest, postRequest, putRequest } from "api/axiosClient";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/quote-request`;

const addParcelQuote = (id, payload) => postRequest(`${baseURL}/${id}/add-parcel-quote`, payload);
const editParcelQuote = (id, payload) => putRequest(`${baseURL}/edit-parcel-quote/${id}`, payload);
const assignCustomsBroker = (id, payload) => putRequest(`${baseURL}/invite-customs-broker/${id}`, payload);
const cancelManualQuote = (id) => putRequest(`${baseURL}/cancel-manual-quote/${id}`);
const cancelProviderInvitation = (id, providerId) => putRequest(`${baseURL}/${id}/provider/${providerId}/cancel`);
const cancelQuoteRequest = (id, payload) => putRequest(`${baseURL}/${id}/cancel`, payload);
const duplicateQuoteRequest = (id) => postRequest(`${baseURL}/${id}/duplicate`);
const exportQuoteRequest = (id, exportUrl) =>
  getRequest(`${baseURL}/${id}/${exportUrl}`, {
    responseType: "blob",
  });
const inviteProvider = (id, providerId) => postRequest(`${baseURL}/${id}/provider/${providerId}/invite`);
const ignoreRequestToCancel = (id) => putRequest(`${baseURL}/${id}/ignore-request-to-cancel`);
const getAuditTrail = (id) => getRequest(`${baseURL}/${id}/audit-trail`);
const getCustomsBrokers = (id) => getRequest(`${baseURL}/list-customs-brokers/${id}`);
const getProviderOptions = (id) => getRequest(`${baseURL}/${id}/provider-options`);
const getQuotations = (id) => getRequest(`${baseURL}/${id}/quotations`);
const getQuotationCount = () => getRequest(`${baseURL}s/count`);
const getQuoteRequestComments = (id) => getRequest(`${baseURL}/${id}/comments`);
const getQuoteRequests = (config = {}) => getRequest(`${baseURL}s`, config);
const getQuoteRequestsV2 = (config = {}) => getRequest(`${baseURL}s/fast`, config);
const getQuoteRequestDetails = (id, config = {}) => getRequest(`${baseURL}/${id}`, config);
const getRequestTimerSettings = () => getRequest(`${baseURL}/request-timer-settings`);
const postQuoteRequestComment = (id, payload) => postRequest(`${baseURL}/${id}/comments`, payload);
const deleteQuoteRequestCommentAttachment = (shipmentId, fileReference) =>
  deleteRequest(`${baseURL}/${shipmentId}/comments/attachments/${fileReference}`);
const requestQuoteRequestCancellation = (id) => putRequest(`${baseURL}/${id}/request-to-cancel`);
const startEditQuoteRequest = (id) => postRequest(`${baseURL}/start-edit-quote-request/${id}`);
const updateRequestTimers = (id, payload) => putRequest(`${baseURL}/${id}/update-request-timers`, payload);
const importQuoteRequest = (payload, config = {}) => postRequest(`${baseURL}/import`, payload, config);
const declineRequest = (id, payload) => putRequest(`${baseURL}/${id}/decline`, payload);
const undoDeclineRequest = (id) => putRequest(`${baseURL}/${id}/decline/undo`);

export {
  addParcelQuote,
  editParcelQuote,
  assignCustomsBroker,
  cancelManualQuote,
  cancelProviderInvitation,
  cancelQuoteRequest,
  duplicateQuoteRequest,
  exportQuoteRequest,
  getAuditTrail,
  getCustomsBrokers,
  getProviderOptions,
  getQuotations,
  getQuoteRequestComments,
  inviteProvider,
  ignoreRequestToCancel,
  getQuotationCount,
  getQuoteRequests,
  getQuoteRequestsV2,
  getRequestTimerSettings,
  postQuoteRequestComment,
  deleteQuoteRequestCommentAttachment,
  requestQuoteRequestCancellation,
  startEditQuoteRequest,
  updateRequestTimers,
  getQuoteRequestDetails,
  importQuoteRequest,
  declineRequest,
  undoDeclineRequest,
};
